const sharedSettings = {
  type: { editable: true, type: 'select', rules: [{ required: true, options: [
    { value: 0, label: 'Good' },
    { value: 1, label: 'Bad' },
  ] }] },

  parent_subcategory: { editable: true, type: 'habit-usersubcategory-select', rules: [{ required: false }] },
  user: { editable: true, type: 'habit-user-select', rules: [{ required: false }] },
  system_habit_name: { editable: true, type: 'hm-habit-select', rules: [{ required: false }] },

  custom_habit_name: { editable: true, type: 'input', rules: [{ required: false }] },

  monday: { editable: true, type: 'switch', rules: [{ required: false }] },
  tuesday: { editable: true, type: 'switch', rules: [{ required: false }] },
  wednesday: { editable: true, type: 'switch', rules: [{ required: false }] },
  thursday: { editable: true, type: 'switch', rules: [{ required: false }] },
  friday: { editable: true, type: 'switch', rules: [{ required: false }] },
  saturday: { editable: true, type: 'switch', rules: [{ required: false }] },
  sunday: { editable: true, type: 'switch', rules: [{ required: false }] },

  duration: { editable: true, type: 'input', rules: [{ required: false }] },
  starts: { editable: true, type: 'time', rules: [{ required: false }] },

  note: { editable: true, type: 'textarea', rules: [{ required: false }] },
  scoring_type: { editable: true, type: 'input', rules: [{ required: false }] },
  motivation: { editable: true, type: 'textarea', rules: [{ required: false }] },
  trigger: { editable: true, type: 'textarea', rules: [{ required: false }] },
  obstacle: { editable: true, type: 'textarea', rules: [{ required: false }] },
  belief: { editable: true, type: 'textarea', rules: [{ required: false }] },

  date: { editable: true, type: 'datetime', rules: [{ type: 'object' as const }] },
  is_periodic: { editable: true, type: 'switch', rules: [{ required: false }] },

  periodic_type: { editable: true, type: 'select', rules: [{ required: false, options: [
    { value: '' },
    { value: 'daily' },
    { value: 'weekly' },
    { value: 'monthly' },
    { value: 'periodic' },
  ] }] },

  repeat_monday: { editable: true, type: 'select', rules: [{ required: false, options: [
    { value: 'yes' },
    { value: 'no' },
  ] }] },

  repeat_tuesday: { editable: true, type: 'select', rules: [{ required: false, options: [
    { value: 'yes' },
    { value: 'no' },
  ] }] },

  repeat_wednesday: { editable: true, type: 'select', rules: [{ required: false, options: [
    { value: 'yes' },
    { value: 'no' },
  ] }] },

  repeat_thursday: { editable: true, type: 'select', rules: [{ required: false, options: [
    { value: 'yes' },
    { value: 'no' },
  ] }] },

  repeat_friday: { editable: true, type: 'select', rules: [{ required: false, options: [
    { value: 'yes' },
    { value: 'no' },
  ] }] },

  repeat_saturday: { editable: true, type: 'select', rules: [{ required: false, options: [
    { value: 'yes' },
    { value: 'no' },
  ] }] },

  repeat_sunday: { editable: true, type: 'select', rules: [{ required: false, options: [
    { value: 'yes' },
    { value: 'no' },
  ] }] },

  periodic_start_date: { editable: true, type: 'datetime', rules: [{ type: 'object' as const }] },
  periodic_end_date: { editable: true, type: 'datetime', rules: [{ type: 'object' as const }] },

  periodic_time: { editable: true, type: 'time', rules: [{ type: 'object' as const }] },
  periodic_server_time: { editable: true, type: 'time', rules: [{ type: 'object' as const }] },

  periodic_duration_hours: { editable: true, type: 'number', rules: [{ required: false }] },
  periodic_duration_minutes: { editable: true, type: 'number', rules: [{ required: false }] },
  repetition_frequency: { editable: true, type: 'number', rules: [{ required: false }] },

  repetition_type: { editable: true, type: 'select', rules: [{ required: false, options: [
    { value: '' },
    { value: 'days' },
    { value: 'weeks' },
    { value: 'months' },
    { value: 'years' },
  ] }] },

  repeat_days_in_month: { editable: true, type: 'input', rules: [{ required: false }] },

  is_key_stone_habit: { editable: true, type: 'switch', rules: [{ required: false }] },
  is_private: { editable: true, type: 'switch', rules: [{ required: false }] },

  habit_status: { editable: true, type: 'select', rules: [{ required: false, options: [
    { value: 'current' },
    { value: 'paused' },
    { value: 'established' },
  ] }] },

  last_notified_date: { editable: true, type: 'datetime', rules: [{ type: 'object' as const }] },

  current_streak: { editable: true, type: 'number', rules: [{ required: true }] },
  current_streak_from: { editable: true, type: 'datetime', rules: [{ type: 'object' as const }] },
  current_streak_to: { editable: true, type: 'datetime', rules: [{ type: 'object' as const }] },

  best_streak: { editable: true, type: 'number', rules: [{ required: true }] },
  best_streak_from: { editable: true, type: 'datetime', rules: [{ type: 'object' as const }] },
  best_streak_to: { editable: true, type: 'datetime', rules: [{ type: 'object' as const }] },

  user_email: { hidden: true },
  /* custom_subcategory_name: { hidden: true },
  system_subcategory_dataname: { hidden: true }, */
  created_at: { hidden: true },
  updated_at: { hidden: true },
}

export const settings = {
  id: { label: "ID" },
  ...sharedSettings
};

export const initialSettings = {
  id: { hidden: true },
  ...sharedSettings,
}

export const initialValues = {
  system_area_name: null,
  user: null
};
